import { render, staticRenderFns } from "./_ChannelGroupForm.vue?vue&type=template&id=e8d50666&"
import script from "./_ChannelGroupForm.vue?vue&type=script&lang=ts&"
export * from "./_ChannelGroupForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports